<head>
    <link href="https://api.mapbox.com/mapbox-gl-js/v2.5.1/mapbox-gl.css" rel="stylesheet">    
    <script src="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.2.2/mapbox-gl-draw.js"></script>
    <link rel="stylesheet" href="https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-draw/v1.2.2/mapbox-gl-draw.css" type="text/css">
</head>
<div style="overflow: hidden;">
    <div [class]="'container alarm-container alarm-'+idAlarmCategory">
        <loading [isLoading]="isLoading"></loading>
        <div *ngIf="!this.isLoading" class="alarm-flex">
            <div [ngClass]="{'col-7': mobileQuery.matches}" class="alarm-map-flex">
                <div id="mini-map"></div>
            </div>

            <div *ngIf="!this.isLoading" [ngClass]="{'col-5': mobileQuery.matches}" class="row alarm-details-flex">
                <!-- titulo y descripción -->
                <div class="popup-title">
                    <!-- hardcodeado por ahora -->
                    <h2 *ngIf="alarmData.idAlarmCategory == null || alarmData.idAlarmCategory == undefined">Alarma de Notificación</h2>
                    <h2 *ngIf="alarmData.idAlarmCategory != undefined && alarmData.idAlarmCategory == 1">Alarma de Notificación</h2>
                    <h2 *ngIf="alarmData.idAlarmCategory != undefined && alarmData.idAlarmCategory == 2">Alarma de Valet Parking</h2>
                    <h2 *ngIf="alarmData.idAlarmCategory != undefined && alarmData.idAlarmCategory == 3">Alarma de Recuperación</h2>
                    <h2 *ngIf="alarmData.idAlarmCategory != undefined && alarmData.idAlarmCategory == 4">Alarma de Geocercas de Seguridad</h2>
        
                    <h1>{{ alarmData.identifier }}</h1>
                    <h3>{{ alarmData.activeDescription}}</h3>
                </div>
        
                <!-- datos -->
                <div style="display: flex; flex-direction: column; align-items: center;">

                    <mat-card class="alarm-data-card">
                        <mat-card-title class="card-title">Duración: {{ alarmData.totalTime }}</mat-card-title>
                        <mat-card-content>
                            <div class="alarm-map-data">
                                <div>
                                    <label >Origen</label>
                                    <p>{{ alarmData.detonatorName }}</p>
                                </div>
                                <div>
                                    <label >Hora Inicial</label>
                                    <p>{{ alarmData.date }} {{ alarmData.hour }}</p>
                                </div>
                                <!-- <div>
                                    <label >Hora Final</label>
                                    <p> {{ alarmData.endAlarm }} </p>
                                </div> -->
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <mat-card class="notification-data-card">
                        <mat-card-title class="card-title"> Notificaciones</mat-card-title>
                        <mat-card-content>
                            <div class="alarm-notifications-details col-12">
                                <label class="col-2" >Tipo</label>
                                <label class="col-7" >Lista de Correos</label>
                                <label class="col-3" >Hora</label>
                            </div>
                            <div class="col-12 alarm-notifications-details" *ngFor="let notification of alarmData.notificationList">
                                <div class="col-2">
                                    <p>{{ notification.notificationType }}</p>
                                </div>
        
                                <div class="col-7">
                                    <p>{{ notification.emailAlert }}</p>
                                </div>
        
                                <div class="col-3">
                                    <p>{{ notification.createdIn | date: 'dd-MM-yy HH:mm' }}</p>
                                </div>
                                
                            </div>
                        </mat-card-content>
                    </mat-card>

                    <alarm-actions style="width: 80%;" [alarmData]="alarmData" [canBeLocked]="canBeLocked" [isLocked]="isLocked"></alarm-actions>
                    
                </div>
        
                <!-- cierre -->
                <div class="close-button">
                    <button (click)="closeDialog()" >Cerrar</button>
                  </div>
              
            </div>
        </div>
      </div>
</div>

  